// Teklif Şablon Editörü kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'documents.offerTemplateEditor';

export const offerTemplateEditorGuide = (t: TFunction): GuideContent => ({
  layout: 'split',
  title: t(`${G}.title`, 'Teklif şablonu nasıl düzenlenir?'),
  intro: t(`${G}.intro`, 'Bu ekranda teklif çıktısının (PDF / baskı) görünümünü tasarlarsınız: kapak, tanıtım sayfaları, teklif sayfası, logo, renkler ve notlar. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Şablon seçimi ve Kaydet'),
    list: t(`${G}.regions.list`, 'Sayfalar / Ayarlar'),
    form: t(`${G}.regions.form`, 'Önizleme'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Şablonu seçin veya yeni açın'),
      text: t(`${G}.s1.text`, 'Üstteki "Şablon" listesinden düzenleyeceğiniz şablonu seçin; varsayılan şablonun yanında ⭐ vardır. "Yeni" düğmesi bir şablon adı sorar ve standart düzenle yeni bir şablon başlatır.'),
    },
    {
      region: 'header',
      title: t(`${G}.s2.title`, '2. Hazır şablonla hızlı başlayın'),
      text: t(`${G}.s2.text`, '"Preset" düğmesi hazır şablonları açar: Kurumsal, Modern, Minimalist ve Detaylı. Birini seçtiğinizde sayfa düzeni, renkler ve yazı ayarları o hazır şablonunkiyle değişir.'),
      tips: [
        t(`${G}.s2.tip1`, 'Dikkat: hazır şablon uygulamak mevcut sayfa ve blok düzeninizi kaldırır, yerine hazır düzeni koyar.'),
        t(`${G}.s2.tip2`, 'Değişiklik "Kaydet"e basana kadar kalıcı olmaz.'),
      ],
    },
    {
      region: 'list',
      title: t(`${G}.s3.title`, '3. Sayfaları düzenleyin'),
      text: t(`${G}.s3.text`, '"Sayfalar" sekmesinde "Ekle" ile Kapak Sayfası, İçerik Sayfası veya Teklif Sayfası ekleyin. Her sayfada göz simgesi sayfayı gizler / gösterir, oklar sırasını değiştirir, çöp kutusu siler.'),
      tips: [
        t(`${G}.s3.tip1`, 'Kapak ve içerik sayfaları serbest tuvaldir: soldaki araç çubuğundan başlık, metin, görsel, şekil veya istatistik kutusu ekleyip sürükleyin.'),
        t(`${G}.s3.tip2`, 'Tuvalde seçtiğiniz elemanın ayarları "Eleman Özellikleri" altında açılır; sayfa başlığını ve arka plan rengini de buradan değiştirirsiniz.'),
      ],
    },
    {
      region: 'list',
      title: t(`${G}.s4.title`, '4. Teklif sayfasının bloklarını ayarlayın'),
      text: t(`${G}.s4.text`, 'Teklif sayfası bloklardan oluşur: Karşılama, Müşteri Bilgileri, Ürün Tablosu, Toplamlar, Koşullar, Banka Bilgileri, İmza Alanı, Alt Bilgi gibi. "Ekle" ile blok ekleyin; göz, ok ve çöp simgeleriyle gizleyin, sıralayın veya silin. Bir bloğa tıklayınca altında "Blok Ayarları" açılır.'),
    },
    {
      region: 'list',
      title: t(`${G}.s5.title`, '5. Genel ayarları girin'),
      text: t(`${G}.s5.text`, '"Ayarlar" sekmesinde Şablon Adı, Slogan, logo, Ana Renk ve Aksan Renk, yazı tipi ve Font Boyutu (10–18 px) ile Ödeme Koşulları, Geçerlilik Notu ve Alt Bilgi Notu bulunur.'),
    },
    {
      region: 'form',
      title: t(`${G}.s6.title`, '6. Önizlemeyi kontrol edin'),
      text: t(`${G}.s6.text`, 'Sağdaki alan seçili sayfayı gösterir. Teklif sayfasında örnek bir teklifle çıktının nasıl görüneceğini görürsünüz; kapak ve içerik sayfalarında bu alan doğrudan düzenlenen tuvaldir.'),
    },
    {
      region: 'header',
      title: t(`${G}.s7.title`, '7. Kaydedin ve varsayılan yapın'),
      text: t(`${G}.s7.text`, '"Kaydet" (yeni şablonda "Oluştur") değişiklikleri saklar; Şablon Adı boşken düğme kapalıdır. Yıldız simgesi ("Varsayılan Yap") şablonu varsayılan yapar: bir teklif görüntülenirken önce bu şablon kullanılır.'),
      tips: [
        t(`${G}.s7.tip1`, 'Yıldız ve "Şablonu Sil" yalnız kayıtlı bir şablon seçiliyken görünür; silmeden önce onay istenir.'),
        t(`${G}.s7.tip2`, 'Sol üstteki ok ("Tekliflere Dön") sizi Teklifler listesine götürür; önce kaydetmeyi unutmayın.'),
      ],
    },
  ],
});
